import { Transition } from '@headlessui/react';
import React from 'react'
import _ from 'lodash';
import { YesNoRendererComponent } from '../../components/yes-no-renderer.component';
import { format } from '../../services/date.service';
import { currency } from '../../services/common.service';


export const ExpandTableComponent = ({ subRowDataId,row,isExpand,columnData,subFilteredFields,subRowData,subColumnDefs,handleExpandTableEdit,handleExpandTableDelete }: any) => (
          <>
          
  {
        subRowDataId === row.Id && isExpand && (
         <tr >
             <td colSpan={10}  className={isExpand ? 'border-b border-2' : 'border-none'} >
             <Transition
         show={isExpand}
         enter="transition-transform duration-50 ease-out"
         leave="transition-transform duration-50 ease-in"
       >
             <table className="w-full text-xs bg-red-50">
             <thead className="w-full border-y border-black border-opacity-20 ">
                     <tr className="w-full text-left h-12">
                       {columnData[0]?.headerName && (
                         <th className="p-4 border-r-2">{columnData[0]?.headerName}</th>
                       )}
                       {subFilteredFields.map((subcolumn: any, index: number) => (
                         <th className="w-auto px-6 py-3 border-r-2 last:border-r-0 whitespace-nowrap " key={index}>{subcolumn.headerName}</th>
                       ))}
                     </tr>
                   </thead>
                   <tbody>
                     {subRowData?.map((subRow: any, subIndex: any) => (
                       <tr
                         key={subIndex}
                         className="bg-white border-2  overflow-y-auto"
                       >
                         
                         {subColumnDefs[0]?.headerName && (
                           <td className="p-4">{subIndex + 1}</td>
                         )}
                     
                         {subFilteredFields.map((subColumn: any, subColumnIndex: number) => {
                           const subDataValue: any = _.property(subColumn.field)(subRow);
       
                           return (
                             <>
                             <td
                               align={subColumn.align}
                               key={subColumnIndex}
                               className="px-10  w-auto"
                             >
                       {
                          subColumn.isCurrencyValueFormat !== true &&
                          subColumn.isDateValueFormat !== true &&
                          subColumn.isAddressFormat !== true &&
                         
                                subColumn.cellRenderer !== 'yesNoRenderer' &&
                                !subColumn.valueFormatter &&
                                subColumn.cellRenderer !== 'viewRenderer' &&
                                
                           subDataValue}
              
                                {subColumn.isCurrencyValueFormat === true && 
                                    <p className=' font-bold'>
                                    {currency(subDataValue)}
                               </p>
                                   }
                                    {subColumn.isDateValueFormat === true && 
                                    <p className=' font-semibold '>
                                    {format(subDataValue)}
                                  </p>
                                   }
                                   {subColumn.isAddressFormat === true && 
                                    <p className=' font-semibold '>
                                    {`${subDataValue?.address?.building} , ${subDataValue?.address?.locality} , ${subDataValue?.address?.city} , ${subDataValue?.address?.country} , ${subDataValue?.address?.state} - ${subDataValue?.address?.area_code}`}
                                  </p>
                                   }
       {subColumn.cellRenderer === 'yesNoRenderer' && (
                                     <YesNoRendererComponent cellRenderer={subColumn.cellRenderer} value={subDataValue} />
                                   )}
      
                     
                       </td>
                       </>
                           
                           );
                         })}
                           {/* <td key={9} className="flex px-5 w-max flex-row  justify-start item-baseline cursor-pointer pt-6 space-x-2">
								  <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleExpandTableEdit(subRow)} width="12" height="12" viewBox="0 0 24 24"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" /></svg>
								  <svg xmlns="http:www.w3.org/2000/svg" onClick={() => handleExpandTableDelete(subRow)} width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>
							  </td> */}
                       </tr>
                     ))}
                   </tbody>
                 </table>
                 </Transition>
             </td>
           </tr>
         )
       }
</>
)
export default ExpandTableComponent;
